import { jsx } from "panel";
import { AuthContainerEl } from "common/widgets/auth-container";
import { ButtonEl } from "common/components/button";
import { ButtonTheme } from "common/components/button/constants";
import { TwoFactorOption, TwoFactorSelectionMenuEl } from "common/widgets/two-factor-selection-menu";
import { SMSTwoFactorEl } from "../sms/index";
import { TotpEl } from "../totp";
export function template() {
  const selection = this.state.selection;
  switch (selection) {
    case TwoFactorOption.SMS:
      return /* @__PURE__ */ jsx(SMSTwoFactorEl, {
        attrs: {
          errors: {},
          step: 0
        }
      });
    case TwoFactorOption.TOTP:
      return /* @__PURE__ */ jsx(TotpEl, {
        on: { back: this.helpers.showSelectionPage }
      });
    default:
      return /* @__PURE__ */ jsx("div", null, /* @__PURE__ */ jsx(AuthContainerEl, {
        sel: ".selector-container",
        attrs: { "show-footer-links": false }
      }, /* @__PURE__ */ jsx("div", {
        sel: ".auth-form",
        attrs: { slot: `auth-form-slot` }
      }, /* @__PURE__ */ jsx("form", null, /* @__PURE__ */ jsx("h1", {
        sel: ".auth-form-title"
      }, "Set Up Two-Factor Authentication"), /* @__PURE__ */ jsx("p", {
        sel: ".auth-form-subtitle"
      }, "Two-factor authentication is ", /* @__PURE__ */ jsx("b", null, "required by your organization."), " Select a method to set up two-factor authentication. You can change this anytime in settings.", ` `, /* @__PURE__ */ jsx("a", {
        sel: ".learn-more-link",
        attrs: {
          href: `https://docs.mixpanel.com/docs/admin/two-factor-authentication#setting-up-your-two-factor-authentication-method`,
          target: `_blank`
        }
      }, "Learn more"), ` `), /* @__PURE__ */ jsx(TwoFactorSelectionMenuEl, {
        sel: this.helpers.MENU_SELECTOR
      }), /* @__PURE__ */ jsx(ButtonEl, {
        attrs: {
          theme: ButtonTheme.Primary
        },
        on: {
          click: this.helpers.showTwoFactorSetUpScreen
        }
      }, "Continue")))));
  }
}
